export class LanguageRow {
    nameEn: string;
    nameFr: string;
    id: number;
    referenceCount?: number;
}
